document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('condoleancesForm').addEventListener('submit', function(e) {
    e.preventDefault();
    
    const nomExpediteur = document.getElementById('nomExpediteur').value;
    const nomDestinataire = document.getElementById('nomDestinataire').value;
    const nomDefunt = document.getElementById('nomDefunt').value;
    const relation = document.getElementById('relation').value;
    const sentiment = document.getElementById('sentiment').value;
    const souhaits = Array.from(document.querySelectorAll('input[name="souhaits"]:checked')).map(el => el.value);
    const pensees_additionnelles = document.getElementById('pensees_additionnelles').value;
    const ton = document.getElementById('ton').value;
    const tutoiement = document.getElementById('tutoiement').value;
    const longueur = document.getElementById('longueur').value;

    function ajusterFormulation(texte) {
      if (tutoiement === 'tutoiement') {
        return texte.replace(/\b(vous|Vous|votre|Votre|vos|Vos|êtes|avez|pouvez|souhaitez|ressentez|exprime|témoigne|souhaite vous|voulais vous|tenais à vous)\b/g, function(match) {
          switch (match) {
            case 'vous':
              return 'tu';
            case 'Vous':
              return 'Tu';
            case 'votre':
              return 'ton';
            case 'Votre':
              return 'Ton';
            case 'vos':
              return 'tes';
            case 'Vos':
              return 'Tes';
            case 'êtes':
              return 'es';
            case 'avez':
              return 'as';
            case 'pouvez':
              return 'peux';
            case 'souhaitez':
              return 'souhaites';
            case 'ressentez':
              return 'ressens';
            case 'exprime':
              return 'exprimes';
            case 'témoigne':
              return 'témoignes';
            case 'souhaite vous':
              return 'souhaite te';
            case 'voulais vous':
              return 'voulais te';
            case 'tenais à vous':
              return 'tenais à te';
            default:
              return match;
          }
        });
      }
      return texte;
    }

    function genererMessage() {
      let message = [];

      const debuts = [
        `Cher/Chère ${nomDestinataire},`,
        `${nomDestinataire},`,
        `Mon/Ma cher(ère) ${nomDestinataire},`
      ];

      const corps = [
        `J'ai appris avec une profonde tristesse le décès de ${nomDefunt}. En tant que ${relation.toLowerCase()}, je tenais à vous exprimer mes sincères condoléances.`,
        `C'est avec une grande émotion que j'ai appris la disparition de ${nomDefunt}. Je voulais vous faire part de toute ma sympathie dans cette douloureuse épreuve.`,
        `La nouvelle du départ de ${nomDefunt} m'a profondément affecté(e). Je souhaite vous témoigner mon soutien le plus sincère dans ces moments difficiles.`
      ];

      message.push(debuts[Math.floor(Math.random() * debuts.length)]);
      message.push(ajusterFormulation(corps[Math.floor(Math.random() * corps.length)]));

      const sentiments = {
        "Souvenir impérissable": `Le souvenir de ${nomDefunt} restera à jamais gravé dans nos cœurs.`,
        "Inspiration véritable": `${nomDefunt} était une véritable source d'inspiration pour tous ceux qui l'ont connu(e).`,
        "Impact durable": `L'impact de ${nomDefunt} sur nos vies perdurera bien au-delà de son départ.`,
        "Apaisement avec le temps": "Avec le temps, j'espère que la douleur s'atténuera pour laisser place à de beaux souvenirs.",
        "Profonde tristesse": "Je ressens une profonde tristesse à l'idée de ne plus revoir cette personne si chère.",
        "Présence irremplaçable": `La présence de ${nomDefunt} était irremplaçable et son absence se fera cruellement sentir.`,
        "Aimé profondément": `${nomDefunt} était profondément aimé(e) et le sera toujours.`,
        "Force dans le souvenir": "Puissiez-vous trouver la force dans les souvenirs que vous partagez.",
        "Dans un lieu meilleur": `J'aime à penser que ${nomDefunt} est maintenant dans un endroit meilleur, en paix.`
      };
      message.push(ajusterFormulation(sentiments[sentiment]));

      const souhaitsPhrases = {
        "Une prière": "Mes prières vous accompagnent dans ces moments difficiles.",
        "Offrir une écoute attentive": "Je suis là pour vous écouter si vous ressentez le besoin de parler.",
        "Proposer de l'aide": "N'hésitez pas à me solliciter si vous avez besoin d'aide, quelle qu'elle soit.",
        "Offrir un soutien ouvert": "Je suis là pour vous soutenir, de quelque manière que ce soit.",
        "Des affirmations positives": "Gardez espoir, le temps apportera l'apaisement.",
        "Des encouragements": "Soyez fort(e), vous traverserez cette épreuve.",
        "Paix et réconfort": "Que la paix et le réconfort vous accompagnent dans ces moments douloureux."
      };
      souhaits.forEach(souhait => message.push(ajusterFormulation(souhaitsPhrases[souhait])));

      if (pensees_additionnelles) {
        message.push(ajusterFormulation(pensees_additionnelles));
      }

      const fins = [
        `Avec toute mon affection,`,
        `Sincères condoléances,`,
        `Avec tout mon soutien,`
      ];
      message.push(fins[Math.floor(Math.random() * fins.length)]);
      message.push(nomExpediteur);

      if (longueur === 'bref') {
        message = message.slice(0, 5);
      } else if (longueur === 'long' && message.length < 8) {
        message.splice(3, 0, ajusterFormulation("Mes pensées sont avec vous dans cette période difficile."));
      }

      return message.join('\n\n');
    }

    const message1 = genererMessage();
    const message2 = genererMessage();

    document.getElementById('messageResult1').innerText = "Proposition 1 :\n\n" + message1;
    document.getElementById('messageResult2').innerText = "Proposition 2 :\n\n" + message2;
  });
});
